import { render, staticRenderFns } from "./OnboardingBanner.vue?vue&type=template&id=06daa1b5&scoped=true"
import script from "./OnboardingBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OnboardingBanner.vue?vue&type=style&index=0&id=06daa1b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06daa1b5",
  null
  
)

export default component.exports